// removed by extract-text-webpack-plugin
module.exports = {"classtop-custom-modal":"classtop-custom-modal","loading":"loading","content":"content","overlay":"overlay","modal-float-body":"modal-float-body","content-wrapper":"content-wrapper","shown":"shown","classtop-modal-wrapper":"classtop-modal-wrapper","classtop-modal-content":"classtop-modal-content","footer":"footer","button-wrapper":"button-wrapper","footer-custom-content":"footer-custom-content","type-grey":"type-grey","type-transparent":"type-transparent","header":"header","close-button":"close-button","header-title":"header-title","header-icon":"header-icon","fa":"fa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/style.scss
// module id = ud+7
// module chunks = 0